import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Inject } from '@angular/core';
import { environment } from '../../environments/environment';

export class UrlServiceConvertingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (req.url.search('layerinfo') > -1 || req.url.search('appinfo') > -1) {
              this.replareUrl(event.body);
              return event.clone({ body: event.body });
            }
          }
          return event;
        })
      )
      ;
  }
  replareUrl(obj) {
    if (obj instanceof Object) {
      let keys = Object.keys(obj);
      if (keys.length > 0) {
        for (const key of keys) {
          if (typeof obj[key] === 'string') {
            let value = obj[key];
            if (value.search('FeatureServer') !== -1 || value.search('MapServer') !== -1) {
              if (!value.startsWith('http')) {
                obj[key] = environment.map.arcgisUrl + value;
              }
            }
          } else {
            this.replareUrl(obj[key]);
          }

        }
      }
    } else if (Array.isArray(obj)) {
      for (const item of obj) {
        this.replareUrl(item);
      }
    }
  }
}